export const initSingleStepFormSteps = (marketoFormDetails) => {
  const { fields } = marketoFormDetails || {};

  const stepFieldKeys = [
    ['Primary_Industry__c', 'industryTestVerticals'],
    ['No_of_Technicians__c'],
    ['fullTimeOffice'],
    ['businessFocusResorCommFORMHELPER', 'businessFocusNewConRemodelSRFORMHELPER'],
    ['Email', 'FirstName', 'LastName', 'Phone', 'Company'],
  ];

  const fieldSetObj = {
    dataType: 'fieldset',
    visibilityRules: {
      ruleType: 'alwaysShow',
      rules: null,
    },
  };

  const stepData =
    (marketoFormDetails &&
      stepFieldKeys.map((x) => ({
        ...fieldSetObj,
        fields: fields
          ?.filter((y) => x?.includes(y.id))
          ?.map((field) =>
            field.id === 'Primary_Industry__c'
              ? {
                  ...field,
                  dataType: 'radioButtons',
                  label: "What is your company's main industry?",
                  instructions: null,
                }
              : field.id === 'No_of_Technicians__c'
              ? {
                  ...field,
                  dataType: 'radioButtons',
                  label: 'How many technicians work at your company?',
                  instructions:
                    'Take your best guess at the number of techs, company-wide, not including office or department workers.',
                  fieldMetaData: {
                    ...field.fieldMetaData,
                    values: field.fieldMetaData.values.filter((item) => item.value !== ''),
                  },
                }
              : field.id === 'fullTimeOffice'
              ? {
                  ...field,
                  dataType: 'radioButtons',
                  label: 'Do you have at least one full-time office employee?',
                  instructions: null,
                }
              : field,
          ),
      }))) ||
    [];

  return stepData;
};

export const initSteps = (marketoFormDetails, isSingleStepForm = false) => {
  if (isSingleStepForm) {
    return initSingleStepFormSteps(marketoFormDetails);
  }

  const { fields } = marketoFormDetails || {};

  const stepData =
    (marketoFormDetails &&
      fields
        ?.filter((x) => x.dataType === 'fieldset')
        .map((x) => ({
          ...x,
          fields: fields?.filter((y) => x.fields?.includes(y.id)),
        }))) ||
    [];

  if (marketoFormDetails && stepData.length === 0) {
    stepData.push({
      fields,
    });
  }
  return stepData;
};

export const evalVisibilityRule = (x, ruleType, values) => {
  let meetsCondition;
  switch (x.operator) {
    case 'is':
      meetsCondition = x.values.includes(values[x.subjectField]);
      break;
    case 'isNot':
      meetsCondition = !x.values.includes(values[x.subjectField]);
      break;
    case 'isEmpty':
      meetsCondition = !values[x.subjectField] || values[x.subjectField].length === 0;
      break;
    case 'isNotEmpty':
      meetsCondition = values[x.subjectField] && values[x.subjectField].length > 0;
      break;
    case 'contains':
      meetsCondition = x.values.some(
        (y) => values[x.subjectField] && values[x.subjectField].includes(y),
      );
      break;
    case 'notContains':
      meetsCondition = x.values.every(
        (y) => !values[x.subjectField] || !values[x.subjectField].includes(y),
      );
      break;
    case 'startsWith':
      meetsCondition = values[x.subjectField].startsWith(x.values);
      break;
    case 'notStartsWith':
      meetsCondition = !values[x.subjectField].startsWith(x.values);
      break;
    case 'between':
      meetsCondition = x.values[0] < values[x.subjectField] && x.values[1] > values[x.subjectField];
      break;
    case 'notBetween':
      meetsCondition = !(
        x.values[0] < values[x.subjectField] && x.values[1] > values[x.subjectField]
      );
      break;
    case 'greaterThan':
      meetsCondition = x.values.every((y) => y < values[x.subjectField]);
      break;
    case 'lessThan':
      meetsCondition = x.values.every((y) => y > values[x.subjectField]);
      break;
    case 'atLeast':
      meetsCondition = x.values.every((y) => y <= values[x.subjectField]);
      break;
    case 'atMost':
      meetsCondition = x.values.every((y) => y >= values[x.subjectField]);
      break;
    default:
      meetsCondition = false;
      break;
  }

  return ruleType === 'show' ? meetsCondition : ruleType === 'hide' ? !meetsCondition : false;
};

export const clearConditionalFieldValues = (fields = [], values = {}) =>
  fields.forEach((field) => {
    if (
      ['show', 'hide'].includes(field.visibilityRules.ruleType) &&
      !field.visibilityRules.rules?.every((rule) =>
        evalVisibilityRule(rule, field.visibilityRules.ruleType, values),
      )
    ) {
      values[field.id] = undefined;
    }
  });

export const getGTMData = () => {
  if (window !== undefined) {
    const gtmData = window.localStorage?.gtm_data;

    return gtmData ? JSON.parse(gtmData) : null;
  }

  return {};
};
